import * as React from "react";
import { InconsistenciaSarlaftForm } from "./InconsistenciasForm";

export default class InconsistenciaSarlaftComponent extends React.Component {

    componentWillMount() {

    }

    componentDidMount() {
    }

    render() {

        return (
            <InconsistenciaSarlaftForm />
        );
    }

    validate = (values: any) => {
    };

    onSubmit = (values: any) => {
    };
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sarlaft/insconsistencias/componentes/InconsisenciasPrincipal.tsx